import { useEffect } from 'react';
import { ONLINE_RECOVERY_MESSAGE } from './catalog.js';
import { subscribeOnlineStatus } from './connectivity.js';
import { showOfflineToast, showOnlineRecoveryToast } from './toast.js';

/** Announces offline assertively and recovery politely — DP-05f / PRM-27 */
export function useConnectivityToasts(enabled = true): void {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') {
      return;
    }

    return subscribeOnlineStatus((online, previous) => {
      if (!online && previous) {
        showOfflineToast();
      } else if (online && !previous) {
        showOnlineRecoveryToast(ONLINE_RECOVERY_MESSAGE);
      }
    });
  }, [enabled]);
}
